import React from 'react';
import './phases.css';

const ACCENT = 'var(--accent, #e8600a)';

/* Animazione dedicata per ogni fase dell'operazione:
   avvio | registrazione | trascrizione | analisi | attesa | standby */
export default function PhaseAnimation({ fase }) {
  switch (fase) {
    case 'registrazione':
      // Chiamata al 456: cornetta al centro dei cerchi (sonar) animati + REC che lampeggia.
      return (
        <svg className="ph-anim" viewBox="0 0 120 120" fill="none">
          <circle className="ph-ring" cx="60" cy="60" r="26" fill="none" stroke={ACCENT} strokeWidth="2.5" />
          <circle className="ph-ring d1" cx="60" cy="60" r="26" fill="none" stroke={ACCENT} strokeWidth="2.5" />
          <circle className="ph-ring d2" cx="60" cy="60" r="26" fill="none" stroke={ACCENT} strokeWidth="2.5" />
          <g transform="translate(36 36) scale(2)">
            <path className="ph-phone" d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.5 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.44 1h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.4a16 16 0 0 0 7.69 7.69l1.76-1.76a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
              fill={ACCENT} />
          </g>
          <circle className="ph-rec" cx="90" cy="30" r="6.5" fill="#ef4444" />
        </svg>
      );

    case 'trascrizione':
      return (
        <div className="ph-anim" style={{ gap: 12 }}>
          <svg width="30" height="56" viewBox="0 0 30 56" fill="none">
            {[0, 1, 2].map(i => (
              <rect key={i} className="ph-wbar" x={2 + i * 11} y="14" width="7" height="28" rx="3"
                fill="#22c55e" style={{ animationDelay: `${i * 0.15}s` }} />
            ))}
          </svg>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, width: 76 }}>
            {['100%', '78%', '92%', '60%'].map((w, i) => (
              <div key={i} className="ph-tl" style={{ '--w': w, animationDelay: `${i * 0.3}s` }} />
            ))}
          </div>
        </div>
      );

    case 'analisi':
      return (
        <svg className="ph-anim" viewBox="0 0 120 120" fill="none">
          <rect x="26" y="24" width="68" height="72" rx="8" fill="rgba(255,255,255,0.07)" stroke="rgba(255,255,255,0.18)" strokeWidth="2" />
          {[40, 54, 68].map((y, i) => (
            <rect key={i} x="36" y={y} width={i === 2 ? 30 : 48} height="6" rx="3" fill="rgba(255,255,255,0.3)" />
          ))}
          <g className="ph-mag">
            <circle cx="46" cy="62" r="14" fill="none" stroke={ACCENT} strokeWidth="4" />
            <line x1="56" y1="72" x2="66" y2="82" stroke={ACCENT} strokeWidth="4" strokeLinecap="round" />
          </g>
          <g className="ph-check">
            <circle cx="84" cy="84" r="15" fill="#22c55e" />
            <path d="M77 84 l5 5 l9 -10" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
          </g>
        </svg>
      );

    case 'attesa':
      return (
        <svg className="ph-anim" viewBox="0 0 120 120" fill="none">
          <circle className="ph-wd" cx="40" cy="60" r="9" fill={ACCENT} />
          <circle className="ph-wd d1" cx="60" cy="60" r="9" fill={ACCENT} />
          <circle className="ph-wd d2" cx="80" cy="60" r="9" fill={ACCENT} />
        </svg>
      );

    case 'standby':
      return (
        <svg className="ph-anim" viewBox="0 0 120 120" fill="none">
          <g className="ph-standby">
            <circle cx="60" cy="60" r="34" fill="none" stroke="#fbbf24" strokeWidth="3" />
            <rect x="48" y="46" width="8" height="28" rx="3" fill="#fbbf24" />
            <rect x="64" y="46" width="8" height="28" rx="3" fill="#fbbf24" />
          </g>
        </svg>
      );

    case 'avvio':
    default:
      return (
        <svg className="ph-anim" viewBox="0 0 120 120" fill="none">
          <circle className="ph-ring" cx="60" cy="60" r="28" fill="none" stroke={ACCENT} strokeWidth="2.5" />
          <circle className="ph-ring d1" cx="60" cy="60" r="28" fill="none" stroke={ACCENT} strokeWidth="2.5" />
          <circle className="ph-ring d2" cx="60" cy="60" r="28" fill="none" stroke={ACCENT} strokeWidth="2.5" />
          <g transform="translate(36 36) scale(2)">
            <path className="ph-phone" d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.5 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.44 1h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.4a16 16 0 0 0 7.69 7.69l1.76-1.76a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
              fill={ACCENT} />
          </g>
        </svg>
      );
  }
}
